import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { useState } from 'react';
import { hooks } from '../../../config/api';
import { comparePossiblyMissingDatesDescending } from '../../utils/comparePossiblyMissingDatesDescending';
import { isEligibilityPending } from '../utils/isEligibilityPending';
import { isEligibilityStale } from '../utils/isEligibilityStale';
var getEligibility = function getEligibility(data) {
  var _data$data$data, _data$data;
  var eligibilities = (_data$data$data = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.data) !== null && _data$data$data !== void 0 ? _data$data$data : [];
  var activeEligibilities = _filterInstanceProperty(eligibilities).call(eligibilities, function (elig) {
    return elig.state === 'active';
  });
  return _sortInstanceProperty(activeEligibilities).call(activeEligibilities, function (a, b) {
    return comparePossiblyMissingDatesDescending(a.verified_at, b.verified_at);
  })[0];
};
export var useFindEligibilityForInsurance = function useFindEligibilityForInsurance(insurance, enabled) {
  var _context, _insurance$eligibilit;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    pollAttempts = _useState2[0],
    setPollAttempts = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    refetchInterval = _useState4[0],
    setRefetchInterval = _useState4[1];
  var invalidateQueries = hooks.useInvalidateQueries();
  var _hooks$useFind = hooks.useFind('eligibilities', {
      id: _mapInstanceProperty(_context = insurance.eligibilities).call(_context, function (el) {
        return el.id;
      }).join()
    }, {
      queryConfig: {
        placeholderData: undefined,
        refetchInterval: refetchInterval,
        enabled: enabled && ((_insurance$eligibilit = insurance.eligibilities) === null || _insurance$eligibilit === void 0 ? void 0 : _insurance$eligibilit.length) > 0,
        onSuccess: function onSuccess(data) {
          if (pollAttempts >= 20) {
            setRefetchInterval(undefined);
            return;
          }
          var eligibility = getEligibility(data);
          var isPending = isEligibilityPending(eligibility);
          var isStale = isEligibilityStale(eligibility);

          // make sure we've polled at least once so we don't get ourselves
          // in an infinite loop when the eligibility is not pending
          if (isStale && pollAttempts > 0) {
            setRefetchInterval(undefined);
            invalidateQueries('insurance');
          }
          if (isPending && pollAttempts < 20) {
            setPollAttempts(pollAttempts + 1);
            setRefetchInterval(1000);
          } else {
            setRefetchInterval(undefined);
          }
        },
        onError: function onError() {
          setRefetchInterval(undefined);
        }
      }
    }),
    data = _hooks$useFind.data;
  var eligibility = getEligibility(data);
  hooks.usePopulate('x12_rejection_reasons', 'x12_rejection_reason', eligibility !== null && eligibility !== void 0 ? eligibility : {});
  return eligibility;
};
//# sourceMappingURL=useFindEligibilityForInsurance.js.map